export interface ContactState {
    contactForm: {
        isShowing: boolean;
        emailText: string;
        messageText: string;
    };
    contactConfirm: {
        isShowing: boolean;
    };
}

export const SHOW_CONTACT_FORM = "SHOW_CONTACT_FORM";
export const HIDE_CONTACT_FORM = "HIDE_CONTACT_FORM";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SHOW_CONTACT_CONFIRM = "SHOW_CONTACT_CONFIRM";
export const HIDE_CONTACT_CONFIRM = "HIDE_CONTACT_CONFIRM";

export interface ShowContactFormAction {
    type: typeof SHOW_CONTACT_FORM;
}

export interface HideContactFormAction {
    type: typeof HIDE_CONTACT_FORM;
}

export interface SendMessageAction {
    type: typeof SEND_MESSAGE;
    payload: {
        emailText: string;
        messageText: string;
    };
}

export interface ShowContactConfirmAction {
    type: typeof SHOW_CONTACT_CONFIRM;
}

export interface HideContactConfirmAction {
    type: typeof HIDE_CONTACT_CONFIRM;
}

export type ContactActionTypes =
    | ShowContactFormAction
    | HideContactFormAction
    | SendMessageAction
    | ShowContactConfirmAction
    | HideContactConfirmAction;
